import { Toast } from 'common/ToastMessage'
import { Spinner } from 'common/Spinner/Spinner'
import { Button } from 'blaze-ui/Button'
import { MessageVariant } from 'common/ToastMessage/Root'

export interface GeneratingContentToastProps {
  onCancel: () => void
  text?: string
  theme?: 'light' | 'dark'
  variant?: MessageVariant
}

export const GeneratingContentToast = ({
  onCancel,
  text = 'Generating your Content...',
  theme = 'light',
  variant = 'rating',
}: GeneratingContentToastProps) => (
  <Toast.Root variant={variant} theme={theme}>
    <Toast.Icon variant={variant}>
      <Spinner />
    </Toast.Icon>
    <Toast.Description>{text}</Toast.Description>
    <Toast.Action>
      <Button variant="tertiary" size="sm" onPress={onCancel}>
        Cancel
      </Button>
    </Toast.Action>
  </Toast.Root>
)
